import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, ModelObjectWithDirtyCheck, type ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class SquarespaceLinkService extends ServiceBase {

  public async initiateOrderImport(squarespaceSettingsId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:api.tenantId.toString(),
    squarespaceSettingsId:squarespaceSettingsId.toString(),
    };
    const extractor = null;
    return this.makeJsonRequest("squarespaceLink/v1/initiateOrderImport", req, true, extractor, opts);
  };
}

export const squarespaceLinkService = new SquarespaceLinkService();